export const SHOW_STREAM = "SHOW_STREAM";
export const HIDE_STREAM = "HIDE_STREAM";
export const TOGGLE_CHAT = "TOGGLE_CHAT";
export const NEW_CHAT_MESSAGES = "NEW_CHAT_MESSAGES";
export const TOGGLE_PLAYER_MODE = "TOGGLE_PLAYER_MODE";
